import {
  WebDiscountValue,
  WebDiscountValueHuseierne,
} from "Constants/constants";

import { TextManager } from "Components/TextContext";
import { AlertTitle } from "Components/TextContext/commonComponentEnums";
import { Keys } from "Components/TextContext/textInterfaces";
import { PRODUCTS_WITH_SUMMER_DISCOUNT } from "Constants/campaigns";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products/index";
import {
  Partner,
  akademikernePartners,
} from "Store/partners/partnerInterfaces";
import { isDefined } from "Utils/functions";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagTask } from "Utils/unleash/flags";

export const handleButtonClick = (
  event:
    | React.MouseEvent<HTMLButtonElement, MouseEvent>
    | React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  onClick?: () => void,
): void => {
  if (event.target instanceof HTMLButtonElement && event.target.disabled) {
    return;
  }
  if (isDefined(onClick)) {
    onClick();
  }
};

export const getDiscountText = (
  partnerId: string,
  product: INSURANCE_NAME_VALUE,
): string => {
  const { getText } = TextManager;
  const summerDiscountFlag = useUnleashFeatureFlag(
    FeatureFlagTask.SSX_815_SUMMER_DISCOUNT,
  );

  const textKey = keyFor(partnerId, product);

  const discountValueHuseierne =
    product === INSURANCE_NAME_VALUE.HOUSE ||
    product === INSURANCE_NAME_VALUE.CABIN
      ? WebDiscountValueHuseierne.HOUSE_AND_CABIN
      : WebDiscountValueHuseierne.OTHER_RISK_PRODUCT;

  try {
    // SSX-815: Summer discount campaign.
    if (summerDiscountFlag && PRODUCTS_WITH_SUMMER_DISCOUNT.includes(product)) {
      return getText(textKey, {
        variables: { webDiscount: WebDiscountValue.SSX_815_SUMMER_DISCOUNT },
      });
    }

    if (partnerId === Partner.HUSEIERNE) {
      return getText(textKey, {
        variables: {
          webDiscount: WebDiscountValue.DEFAULT,
          webDiscount_huseierne: discountValueHuseierne,
        },
      });
    }

    return getText(textKey, {
      variables: { webDiscount: WebDiscountValue.DEFAULT },
    });
  } catch (error) {
    return getText(AlertTitle.WEB_DISCOUNT, {
      variables: { webDiscount: WebDiscountValue.DEFAULT },
    });
  }
};

const keyFor = (partnerId: string, productName: INSURANCE_NAME_VALUE): Keys => {
  const keyPrefix = "form.discount.webdiscount_";
  if (akademikernePartners.some((p) => p === partnerId)) {
    return `${formatProductName(productName)}${keyPrefix}akademikerne` as Keys;
  }
  return `${formatProductName(productName)}${keyPrefix}${partnerId}` as Keys;
};

const formatProductName = (product: INSURANCE_NAME_VALUE): string => {
  if (product === INSURANCE_NAME_VALUE.ELECTRIC_SCOOTER) {
    return product.toLowerCase().split("_").join("");
  }
  return product.toLowerCase();
};
